module.exports = __webpack_public_path__ + "img/10.d88d2a8b.jpg";